export function isKetchDisabled(): boolean {
  if (typeof window === 'undefined') return false;

  const disableKetchPatterns = [
    'https://brand.databricks.com/',
    'https://brandguides.brandfolder.com/databricks-extended-brand-guidelines'
  ];

  const host = window.location.hostname; // e.g. "brand.databricks.com"
  const pathname = window.location.pathname; // e.g. "/databricks-extended-brand-guidelines"

  return disableKetchPatterns.some((pattern) => {
    if (/^https?:\/\//i.test(pattern)) {
      try {
        const p = new URL(pattern);
        if (host !== p.hostname) return false;

        if (!p.pathname || p.pathname === '/') return true;

        return pathname.startsWith(p.pathname);
      } catch {
        return false;
      }
    }

    return host === pattern;
  });
}
